import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { EventCard } from '../../features/events/EventCard';
import { useMatchingEventViews } from '../../features/matching/useMatchingEventViews';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { fetchEventById } from '../../store/thunks';

import './EventDetailPage.css';

export function EventDetailPage() {
  const { eventId } = useParams<{ eventId: string }>();
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const membersOpen = searchParams.get('members') === 'open';
  useMatchingEventViews(React.useMemo(() => (eventId ? [eventId] : []), [eventId]));

  const event = useAppSelector((s) =>
    s.entities.events.items.find((e) => e.id === eventId),
  );

  const [isLoading, setIsLoading] = React.useState(!event);
  const [hasError, setHasError] = React.useState(false);

  React.useEffect(() => {
    if (!eventId) return;
    let cancelled = false;

    const run = async () => {
      setIsLoading(true);
      setHasError(false);
      try {
        await dispatch(fetchEventById({ eventId })).unwrap();
      } catch {
        if (!cancelled) setHasError(true);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    void run();
    return () => { cancelled = true; };
  }, [dispatch, eventId]);

  return (
    <div className="event-detail-page">
      <div className="event-detail-page__header">
        <button
          className="event-detail-page__back"
          onClick={() => navigate('/events')}
        >
          ← Приключения
        </button>
      </div>

      <div className="event-detail-page__content">
        {isLoading ? (
          <div className="tavern-loading">
            <div className="tavern-spinner" />
          </div>
        ) : hasError || !event ? (
          <div className="tavern-empty-state">
            <div className="tavern-empty-state-icon">🗺️</div>
            <div className="tavern-empty-state-title">Мероприятие не найдено</div>
            <div className="tavern-empty-state-description">
              Возможно, оно было удалено или отменено
            </div>
          </div>
        ) : (
          <EventCard event={event} membersOpen={membersOpen} showDescription />
        )}
      </div>
    </div>
  );
}
